export const ANONYMOUS_UID = 'anonymous';
